module.exports = __webpack_public_path__ + "static/media/pic1.ce0a5c0a.png";